export default __webpack_public_path__ + "static/media/logo.7072c629.jpg";